module.exports = __webpack_public_path__ + "img/1.ed415763.svg";